import type { SuperHubRouteParams } from '../types';
import type { HubResponseProps } from '@readme/iso';

import React from 'react';
import { useParams } from 'react-router-dom';

import useClassy from '@core/hooks/useClassy';

import SectionGate from '@routes/SuperHub/components/PlanAccess/SectionGate';
import Recipes from '@routes/Tutorials';

import styles from './index.module.scss';

export default function SuperHubRecipes(props: HubResponseProps) {
  const bem = useClassy(styles, 'SuperHubRecipes');
  const { slug } = useParams<SuperHubRouteParams>();

  return (
    <SectionGate contentClassName={bem('-gate-content')} section="recipes">
      {/* Provide the slug from SuperHubRouteParams to ensure it updates with browser history (i.e. browser back / forward controls).
      The Recipes component is from the legacy Dash so passing in the prop here to reduce modifications to the component and 
      maintain backwards compatibility. */}
      <Recipes {...props} slug={slug} />
    </SectionGate>
  );
}
